import { GenericResponse } from 'types/GenericResponse';
import { createAsyncReducer } from 'utils/Redux';
import { EditPlanMeta } from 'types/store/ContentPlanner';

import { editPlanActions } from '../../actions';

export default createAsyncReducer<EditPlanMeta, GenericResponse>(
  editPlanActions,
);
